import {
  Badge,
  Box,
  Button,
  Flex,
  Tooltip,
  ActionIcon,
  Modal,
  Text,
  Image,
  Table,
  TextInput,
  Select,
  Grid,
} from "@mantine/core";
import {
  IconSearch,
  IconMail,
  IconUser,
  IconRefresh,
  IconCalendarUp,
  IconCalendarDown,
  IconStatusChange,
} from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { DatePickerInput } from "@mantine/dates";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  keySearchCompareSaleOrderWeb,
  repositoryCart,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { green, olive_green, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { useCallback } from "react";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { _localization } from "../../config/location";

// Định nghĩa kiểu dữ liệu đơn hàng sale order từ API tblSaleOrder
interface SaleOrder {
  id: number; // ID đơn hàng
  assignToId?: number; // ID người được giao
  assignToName?: string; // Tên người được giao
  orderNumber: string; // Mã đơn hàng
  orderDate: string; // Ngày đặt hàng
  orderType?: string; // Loại đơn hàng
  customerId: number; // ID khách hàng
  customerSiteId?: number; // ID địa chỉ khách hàng
  buyerId?: number; // ID người mua
  buyerEmail: string; // Email người mua
  provinceId?: number; // ID tỉnh/thành
  districtId?: number; // ID quận/huyện
  communeId?: number; // ID phường/xã
  buyerName: string; // Tên người mua
  totalAmount: number; // Tổng tiền ban đầu
  orderPromotion?: string; // Khuyến mãi đơn hàng
  shipMethod?: string; // Phương thức giao hàng
  shippingStatus: string; // Trạng thái giao hàng
  shippingInfo?: string; // Thông tin giao hàng
  shippingComment?: string; // Ghi chú giao hàng
  shippingUpdateTime?: string; // Thời gian cập nhật giao hàng
  shippingUpdateBy?: string; // Người cập nhật giao hàng
  shippingCompany?: string; // Công ty giao hàng
  shippingFee?: number; // Phí giao hàng
  codfee?: number; // Phí COD
  shippingNote?: string; // Ghi chú giao hàng
  shippingAddress?: string; // Địa chỉ giao hàng
  payMethodId: number; // ID phương thức thanh toán
  payStatus?: string; // Trạng thái thanh toán
  receivePayStatus?: string; // Trạng thái nhận thanh toán
  successStatus?: string; // Trạng thái thành công
  buyerInstruction?: string; // Hướng dẫn từ người mua
  description?: string; // Mô tả
  buyerFeedBackId?: number; // ID phản hồi người mua
  discountPrice?: number; // Giá chiết khấu
  discountInfo?: string; // Thông tin chiết khấu
  orderFees?: number; // Phí đơn hàng
  orderDiscount?: number; // Chiết khấu đơn hàng
  discount: number; // Tổng chiết khấu
  discountNote?: string; // Ghi chú chiết khấu
  orderStatus: string; // Trạng thái đơn hàng
  orderMessage?: string; // Tin nhắn đơn hàng
  orderComment: string; // Bình luận đơn hàng
  orderStatusDate?: string; // Ngày trạng thái đơn hàng
  orderStatusUpdateBy?: string; // Người cập nhật trạng thái
  caresoftTicketId?: string; // ID ticket caresoft
  creationDate: string; // Ngày tạo
  createdBy?: string; // Người tạo
  lastUpdateDate?: string; // Ngày cập nhật cuối
  lastUpdatedBy?: string; // Người cập nhật cuối
  lastUpdateLogin?: string; // Login cập nhật cuối
  taxCode?: string; // Mã số thuế
  taxCompany?: string; // Công ty thuế
  taxAddress?: string; // Địa chỉ thuế
  buyerInfo?: string; // Thông tin người mua
  buyerTelephone: string; // SĐT người mua
  voucherId?: number; // ID voucher
  voucherValue?: number; // Giá trị voucher
  voucherCode?: string; // Mã voucher
  totalRemainingAmount: number; // Tổng tiền còn lại
  attribute1?: string; // Thuộc tính 1
  attribute2?: string; // Thuộc tính 2
  attribute3?: string; // Thuộc tính 3
  attribute4?: string; // Thuộc tính 4
  attribute5?: string; // Thuộc tính 5
  attribute6?: string; // Thuộc tính 6
  attribute7?: string; // Thuộc tính 7
  attribute8?: string; // Thuộc tính 8
  attribute9?: string; // Thuộc tính 9
  attribute10?: string; // Thuộc tính 10
  attribute11?: string; // Thông tin địa chỉ (JSON)
  attribute12?: string; // Địa chỉ đầy đủ
  attribute13?: string; // Thuộc tính 13
  attribute14?: string; // Thuộc tính 14
  attribute15?: string; // Thuộc tính 15
  attribute16?: string; // Thuộc tính 16
  attribute17?: string; // Thuộc tính 17
  attribute18?: string; // Trạng thái đặt hàng
  attribute19?: string; // Thuộc tính 19
  attribute20?: string; // Thuộc tính 20
  attribute21?: string; // Thuộc tính 21
  attribute22?: string; // Thuộc tính 22
  attribute23?: string; // Thuộc tính 23
  attribute24?: string; // Thuộc tính 24
  attribute25?: string; // Thuộc tính 25
  attribute26?: string; // Thuộc tính 26
  attribute27?: string; // Thuộc tính 27
  attribute28?: string; // Thuộc tính 28
  attribute29?: string; // Thuộc tính 29
  attribute30?: string; // Thuộc tính 30
  attribute31?: string; // Thuộc tính 31
  attribute32?: string; // Thuộc tính 32
  attribute33?: string; // Thuộc tính 33
  attribute34?: string; // Thuộc tính 34
  attribute35?: string; // Thuộc tính 35
  attribute36?: string; // Thuộc tính 36
  attribute37?: string; // Thuộc tính 37
  attribute38?: string; // Thuộc tính 38
  attribute39?: string; // Thuộc tính 39
  attribute40?: string; // Thuộc tính 40
  promotionValue1?: number; // Giá trị KM 1
  promotionValue2?: number; // Giá trị KM 2
  promotionValue3?: number; // Giá trị KM 3
  promotionValue4?: number; // Giá trị KM 4
  promotionValue5?: number; // Giá trị KM 5
  listItemCodeAddOn?: string; // Danh sách mã addon
  listItemCodeGift?: string; // Danh sách mã quà tặng
  totalAmountFinal: number; // Tổng tiền cuối cùng
  amountPaid: number; // Số tiền đã thanh toán
  installmentAmountTotal?: number; // Tổng tiền trả góp
  installmentAmountRemaing?: number; // Tiền trả góp còn lại
  expireTime?: string; // Thời gian hết hạn
  tblSaleOrderDetailModels: SaleOrderDetail[]; // Danh sách sản phẩm
}

// Định nghĩa kiểu dữ liệu chi tiết sản phẩm trong đơn hàng
interface SaleOrderDetail {
  id: number;
  headerId: number;
  itemType: string;
  itemId: number;
  itemName: string;
  itemInformation?: string;
  itemPrice: number;
  quantity: number;
  promotion?: string;
  itemImage: string;
  itemUrl?: string;
  totalAmount: number;
  itemNote?: string;
  itemAddon?: string;
  creationDate: string;
  createdBy?: string;
  lastUpdateDate?: string;
  lastUpdatedBy?: string;
  lastUpdateLogin?: string;
  cartDetailId: number;
  inCart?: string;
  itemSku?: string;
  itemCode: string;
  warrantyDescription?: string;
  finalPrice: number;
  isService: boolean;
  isAddOn: boolean;
  isWarranty: boolean;
  isGift: boolean;
  isPrimary?: boolean;
  promotionCode?: string;
  itemPrimaryId?: number;
  itemPrimaryCode?: string;
}

const CompareSaleOrderWeb = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<SaleOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);

  // State cho modal hiển thị chi tiết sản phẩm
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<SaleOrder | null>(null);
  console.log(selectedOrder);

  // State cho đồng bộ
  const [syncingOrderId, setSyncingOrderId] = useState<number | null>(null);

  // Form tìm kiếm
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = localStorage.getItem(keySearchCompareSaleOrderWeb)
    ? JSON.parse(localStorage.getItem(keySearchCompareSaleOrderWeb) ?? "")
    : null;
  const searchForm = useForm({
    initialValues: {
      BuyerId: _searchJson && checkedPinSearch ? _searchJson?.BuyerId : "",
      BuyerEmail:
        _searchJson && checkedPinSearch ? _searchJson?.BuyerEmail : "",
      StartDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.StartDate
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      EndDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.EndDate
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      Status: _searchJson && checkedPinSearch ? _searchJson?.Status : "",
      IssuedUser:
        _searchJson && checkedPinSearch ? _searchJson?.IssuedUser : "",
      CustomerId:
        _searchJson && checkedPinSearch ? _searchJson?.CustomerId : "",
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    },
  });

  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  // Hàm xử lý khi click vào mã đơn hàng để xem chi tiết sản phẩm
  const handleViewOrderDetails = (order: SaleOrder) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  // Hàm đóng modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  // Hàm gọi API đồng bộ
  const handleSyncToPos = async (order: SaleOrder) => {
    setSyncingOrderId(order.id);
    try {
      const response = await repositoryCart.post<MessageResponse<any>>(
        "/api/v1/tblSaleOrder/sync-to-pos",
        {
          orderId: order.id,
          orderNumber: order.orderNumber,
        },
      );

      if (response && response.success) {
        NotificationExtension.Success("Đồng bộ thành công!");
      } else {
        NotificationExtension.Fails(response?.message || "Đồng bộ thất bại!");
      }
    } catch (error) {
      console.error("Lỗi khi đồng bộ:", error);
      NotificationExtension.Fails("Lỗi khi đồng bộ!");
    } finally {
      setSyncingOrderId(null);
    }
  };

  // Hàm gọi API lấy danh sách đơn hàng từ tblSaleOrder
  const fetchData = async () => {
    setIsLoading(true);
    try {
      let url = `/api/v1/tblSaleOrder/get-list-admin?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;
      const params: string[] = [];

      // Lấy giá trị từ form tìm kiếm
      const {
        BuyerId,
        BuyerEmail,
        StartDate,
        EndDate,
        Status,
        IssuedUser,
        CustomerId,
        KeySearch,
      } = searchForm.values;

      if (BuyerId) params.push(`BuyerId=${encodeURIComponent(BuyerId)}`);
      if (BuyerEmail)
        params.push(`BuyerEmail=${encodeURIComponent(BuyerEmail)}`);
      if (StartDate) {
        params.push(`StartDate=${StartDate}`);
      }
      if (EndDate) {
        params.push(`EndDate=${EndDate}`);
      }
      if (Status) params.push(`Status=${encodeURIComponent(Status)}`);
      if (IssuedUser)
        params.push(`IssuedUser=${encodeURIComponent(IssuedUser)}`);
      if (CustomerId)
        params.push(`CustomerId=${encodeURIComponent(CustomerId)}`);
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);

      if (params.length > 0) {
        url += "&" + params.join("&");
      }

      // Gọi API thông qua repositoryCart
      const response = await repositoryCart.get<MessageResponse<any>>(url);
      if (response && response.success) {
        console.log("Response data:", response.data);
        setData(response.data || []);
        setRowCount(response?.totalCount || response.totalCount || 0);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setRowCount(0);
      console.error("Error fetching sale orders:", error);
    } finally {
      setIsLoading(false);
      localStorage.setItem(
        keySearchCompareSaleOrderWeb,
        JSON.stringify(searchForm.getValues()),
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageSize, pagination?.pageIndex]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Định nghĩa columns cho MantineReactTable
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        // Đếm ngược từ tổng số dòng: đơn mới nhất mang số lớn nhất,
        // giảm dần qua từng trang cho tới dòng cuối cùng là số 1.
        // Phân trang chạy phía máy chủ nên phải tự tính theo trang đang xem,
        // row.index chỉ là thứ tự trong trang.
        Cell: ({ row }) => (
          <>
            {rowCount - pagination.pageIndex * pagination.pageSize - row.index}
          </>
        ),
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Click để xem chi tiết sản phẩm">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onClick={() => handleViewOrderDetails(row.original)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "attribute9",
        header: "Trạng thái đồng bộ",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === "THANH_CONG" ? "Đã đồng bộ" : ""}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        enableColumnFilter: false,
        size: 200,
        // Cell: ({ row }) => {
        //   const orderStatus = row.original.orderStatus;
        //   let badgeColor;
        //   switch (orderStatus) {
        //     case "DON_HANG_TAM":
        //       badgeColor = "cyan";
        //       break;
        //     case "DON_HANG_CHOT":
        //       badgeColor = "violet";
        //       break;
        //     case "DON_HANG_DOI_TRA_TAM":
        //       badgeColor = "cyan";
        //       break;
        //     case "DON_HANG_HOAN_THANH":
        //       badgeColor = "green";
        //       break;
        //     case "DON_HANG_DOI_TRA":
        //       badgeColor = "green";
        //       break;
        //     case "THANH_TOAN_CHUA_HOAN_THANH":
        //       badgeColor = "red";
        //       break;
        //     case "pending":
        //       badgeColor = "yellow";
        //       break;
        //     case "DON_HANG_BAN_TAI_SHOP":
        //       badgeColor = "green";
        //       break;
        //     case "DON_HANG_CHO_DUYET_GIAM":
        //       badgeColor = olive_green.light;
        //       break;
        //     case "DON_HANG_DA_DUYET_GIAM":
        //       badgeColor = olive_green.medium;
        //       break;
        //     case "KHO_XUAT_HANG":
        //       badgeColor = sky_blue.medium;
        //       break;
        //     case "DON_HANG_DONG":
        //       badgeColor = "red";
        //       break;
        //     default:
        //       badgeColor = "gray";
        //   }
        //   return (
        //     <Badge
        //       size="md"
        //       color={badgeColor}
        //       fs={"12,5px"}
        //       fw={"bold"}
        //       radius="sm"
        //     >
        //       {row.original.orderStatus !== null
        //         ? getTextStatus(row)
        //         : "Không HỢP LỆ"}
        //     </Badge>
        //   );
        // },
      },
      {
        accessorKey: "attribute18",
        header: "Trạng thái thanh toán",
        size: 225,
        Cell: ({ renderedCellValue }) => {
          const statusText =
            renderedCellValue === "DA_THANH_TOAN"
              ? "Đã thanh toán"
              : renderedCellValue === "CHO_THANH_TOAN"
                ? "Chờ thanh toán"
                : "Chưa thanh toán";
          return (
            <Badge
              size="sm"
              color={
                renderedCellValue === "DA_THANH_TOAN"
                  ? "green"
                  : renderedCellValue === "CHO_THANH_TOAN"
                    ? "yellow"
                    : "gray"
              }
            >
              {statusText || "N/A"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "orderDate",
        header: "Ngày đặt hàng",
        size: 180,
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return (
              <Text fw={500} size="12.5px">
                {formatDateTransfer(renderedCellValue)}
              </Text>
            );
          }
          return (
            <Text fw={500} size="12.5px">
              {formatDateTransfer(undefined)}
            </Text>
          );
        },
      },
      {
        accessorKey: "buyerName",
        header: "Tên khách hàng",
        size: 180,
        enableColumnFilter: false,
      },
      {
        accessorKey: "buyerTelephone",
        header: "SĐT khách hàng",
        size: 175,
        enableColumnFilter: false,
      },
      {
        accessorKey: "buyerEmail",
        header: "Email khách hàng",
        size: 200,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute12",
        header: "Địa chỉ giao hàng",
        size: 350,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || "N/A"}>
            <div
              style={{
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {renderedCellValue || "N/A"}
            </div>
          </Tooltip>
        ),
      },
      {
        accessorKey: "attribute13",
        header: "Địa chỉ lấy hàng tại chi nhánh",
        size: 350,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || "Không có địa chỉ lấy hàng"}>
            <div
              style={{
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {renderedCellValue || "N/A"}
            </div>
          </Tooltip>
        ),
      },
      {
        accessorKey: "totalAmount",
        header: "Tổng tiền ban đầu",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <>
            {new Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(Number(renderedCellValue) || 0)}
          </>
        ),
      },
      {
        accessorKey: "discount",
        header: "Chiết khấu",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <span style={{ color: "red" }}>
            {new Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(Number(renderedCellValue) || 0)}
          </span>
        ),
      },
      {
        accessorKey: "totalAmountFinal",
        header: "Tổng tiền cuối",
        size: 180,
        Cell: ({ renderedCellValue }) => (
          <strong style={{ color: "green" }}>
            {new Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(Number(renderedCellValue) || 0)}
          </strong>
        ),
      },
      {
        accessorKey: "amountPaid",
        header: "Đã thanh toán",
        size: 180,
        Cell: ({ renderedCellValue }) => (
          <>
            {new Intl.NumberFormat("vi-VN", {
              style: "currency",
              currency: "VND",
            }).format(Number(renderedCellValue) || 0)}
          </>
        ),
      },
      {
        accessorKey: "totalRemainingAmount",
        header: "Còn lại",
        size: 140,
        Cell: ({ renderedCellValue }) => {
          const amount = Number(renderedCellValue) || 0;
          return (
            <span style={{ color: amount > 0 ? "orange" : "green" }}>
              {new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND",
              }).format(amount)}
            </span>
          );
        },
      },
      {
        accessorKey: "tblSaleOrderDetailModels",
        header: "Số sản phẩm",
        size: 180,
        Cell: ({ renderedCellValue }) => (
          <>{Array.isArray(renderedCellValue) ? renderedCellValue.length : 0}</>
        ),
      },
      {
        accessorKey: "orderComment",
        header: "Ghi chú",
        size: 200,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || "Không có ghi chú"}>
            <div
              style={{
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {renderedCellValue || ""}
            </div>
          </Tooltip>
        ),
      },
      {
        accessorKey: "shippingInfo",
        header: "Thông tin giao hàng",
        size: 400,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <Tooltip label={renderedCellValue || "Không có thông tin"}>
            <div
              style={{
                maxWidth: "400px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {renderedCellValue || ""}
            </div>
          </Tooltip>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 80,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const actions = [];
          // Đồng bộ lại đơn hàng
          actions.push(
            <Tooltip label="Đồng bộ lại" key="sync-order">
              <ActionIcon
                variant="light"
                aria-label="Đồng bộ lại"
                color="green"
                loading={syncingOrderId === row.original.id}
                onClick={() => handleSyncToPos(row.original)}
                disabled={row.original.attribute9 === "THANH_CONG"}
              >
                <IconRefresh size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>,
          );

          return <Flex gap={10}>{actions}</Flex>;
        },
      },
    ],
    // rowCount và pagination phải nằm ở đây, không thì cột STT giữ số của lần dựng đầu
    // và không đổi khi lật trang hay khi tổng số dòng thay đổi
    [syncingOrderId, rowCount, pagination.pageIndex, pagination.pageSize],
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowSelection: false,
    manualPagination: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "orderNumber"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onPaginationChange: setPagination,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      {/* Form tìm kiếm */}
      <div ref={headerRef}>
        <_breadcrumb></_breadcrumb>
        <Grid>
          {/* <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <TextInput
              leftSection={<IconUserCode color="#15aabf" />}
              placeholder="Id người mua"
              {...searchForm.getInputProps("BuyerId")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col> */}
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <TextInput
              leftSection={<IconMail color="#15aabf" />}
              placeholder="Email Buyer"
              {...searchForm.getInputProps("BuyerEmail")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <DatePickerInput
              leftSection={<IconCalendarUp color="#15aabf" />}
              size="sm"
              placeholder="Ngày bắt đầu"
              value={
                searchForm.getValues()?.StartDate &&
                String(searchForm.getValues()?.StartDate).length > 0
                  ? new Date(searchForm.getValues()?.StartDate)
                  : null
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) =>
                searchForm.setValues((prev) => ({
                  ...prev,
                  StartDate: e
                    ? new Date(
                        new Date(e)?.getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <DatePickerInput
              leftSection={<IconCalendarDown color="#15aabf" />}
              size="sm"
              placeholder="Ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                searchForm.getValues()?.EndDate &&
                String(searchForm.getValues()?.EndDate).length > 0
                  ? new Date(searchForm.getValues()?.EndDate)
                  : null
              }
              onChange={(e) =>
                searchForm.setValues((prev) => ({
                  ...prev,
                  EndDate: e
                    ? new Date(
                        new Date(e)?.getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <Select
              placeholder="Trạng thái"
              leftSection={<IconStatusChange color="#15aabf" />}
              data={[
                { value: "CHO_XAC_NHAN", label: "Chờ xác nhận" },
                { value: "DA_XAC_NHAN", label: "Đã xác nhận" },
                { value: "DANG_GIAO_HANG", label: "Đang giao hàng" },
                { value: "HOAN_THANH", label: "Hoàn thành" },
                { value: "HUY_BO", label: "Hủy bỏ" },
                { value: "CHO_THANH_TOAN", label: "Chờ thanh toán" },
                { value: "DA_THANH_TOAN", label: "Đã thanh toán" },
              ]}
              {...searchForm.getInputProps("Status")}
              clearable
              searchable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <TextInput
              leftSection={<IconUser color="#15aabf" />}
              placeholder="Người tạo"
              {...searchForm.getInputProps("IssuedUser")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <TextInput
              leftSection={<IconSearch color="#15aabf" />}
              placeholder="Từ khóa tìm kiếm"
              {...searchForm.getInputProps("KeySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 4, lg: 2.4 }}>
            <Flex gap="sm">
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={fetchData}
              >
                Tìm kiếm
              </Button>
              <Button
                color="gray"
                variant="outline"
                onClick={() => {
                  searchForm.reset();
                  fetchData();
                }}
              >
                Xóa bộ lọc
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>

      {/* Modal hiển thị chi tiết sản phẩm trong đơn hàng */}
      <Modal
        opened={isModalOpen}
        onClose={handleCloseModal}
        title={`Chi tiết sản phẩm - Đơn hàng: ${
          selectedOrder?.orderNumber || ""
        }`}
        size="xl"
      >
        {selectedOrder && (
          <Box>
            {/* Thông tin tóm tắt đơn hàng */}
            <Box
              my="md"
              p="md"
              style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
            >
              <Text size="sm" fw={500} mb="xs">
                Thông tin đơn hàng:
              </Text>
              <Text size="sm">
                Khách hàng: {selectedOrder.buyerName || "N/A"}
              </Text>
              <Text size="sm">Email: {selectedOrder.buyerEmail || "N/A"}</Text>
              <Text size="sm">
                Địa chỉ giao hàng: {selectedOrder.attribute12 || "N/A"}
              </Text>
              <Text size="sm">
                Ngày đặt:{" "}
                {selectedOrder.creationDate
                  ? formatDateTransfer(selectedOrder.creationDate)
                  : "N/A"}
              </Text>
              <Text size="sm">
                Trạng thái: {selectedOrder.orderStatus || "N/A"}
              </Text>
              <Text size="sm">
                Phương thức giao hàng: {selectedOrder.shipMethod || "N/A"}
              </Text>
            </Box>

            {/* Bảng chi tiết sản phẩm */}
            <Table striped highlightOnHover withTableBorder mt={"md"}>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>STT</Table.Th>
                  <Table.Th>Hình ảnh</Table.Th>
                  <Table.Th>Mã sản phẩm</Table.Th>
                  <Table.Th>Tên sản phẩm</Table.Th>
                  <Table.Th>Đơn giá</Table.Th>
                  <Table.Th>Số lượng</Table.Th>
                  <Table.Th>Thành tiền</Table.Th>
                  <Table.Th>Ghi chú</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {selectedOrder.tblSaleOrderDetailModels?.map((item, index) => (
                  <Table.Tr key={item.id}>
                    <Table.Td>{index + 1}</Table.Td>
                    <Table.Td>
                      {item.itemImage ? (
                        <Image
                          src={item.itemImage}
                          alt={item.itemName}
                          width={50}
                          height={50}
                          fit="cover"
                          radius="sm"
                          onError={(e) => {
                            (e.target as HTMLImageElement).src =
                              "/placeholder-image.png";
                          }}
                        />
                      ) : (
                        <Text size="xs" c="dimmed">
                          Không có ảnh
                        </Text>
                      )}
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm" fw={500}>
                        {item.itemCode || "N/A"}
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">{item.itemName || "N/A"}</Text>
                      {item.itemInformation && (
                        <Text size="xs" c="dimmed">
                          {item.itemInformation}
                        </Text>
                      )}
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm">
                        {item.itemPrice?.toLocaleString("vi-VN") || "0"} VNĐ
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm" fw={500}>
                        {item.quantity || 0}
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm" fw={500} c="blue">
                        {item.totalAmount?.toLocaleString("vi-VN") || "0"} VNĐ
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="xs">{item.itemNote || "-"}</Text>
                    </Table.Td>
                  </Table.Tr>
                )) || (
                  <Table.Tr>
                    <Table.Td colSpan={8} style={{ textAlign: "center" }}>
                      <Text c="dimmed">Không có sản phẩm nào</Text>
                    </Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>

            {/* Tổng tiền */}
            <Box
              mt="lg"
              p="md"
              style={{
                backgroundColor: "#f8fafc",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
              }}
            >
              <Flex wrap={"wrap"} gap={"xl"} justify={"end"}>
                <Box>
                  <Text size="md" fw={600} c="blue" ta="right">
                    Chiết khấu:{" "}
                    {selectedOrder.discount?.toLocaleString("vi-VN") || "0"} VNĐ
                  </Text>
                </Box>
                <Box>
                  <Text size="md" fw={600} c="blue" ta="right">
                    Tổng tiền cuối cùng:{" "}
                    {selectedOrder.totalAmountFinal?.toLocaleString("vi-VN") ||
                      "0"}{" "}
                    VNĐ
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>
        )}
      </Modal>
    </>
  );
};

export default CompareSaleOrderWeb;
